import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../../context/AppContext";
import EnquiryListPanel from "./EnquiryListPanel";

const STATUS_FILTERS = [
  { id: "all", label: "All" },
  { id: "Approved", label: "Approved" },
  { id: "Seated", label: "Seated" },
  { id: "needs_approval", label: "Needs Approval" },
];

function matchesStatusFilter(item, filterId) {
  const status = item?.status;

  if (filterId === "all") return true;
  if (filterId === "needs_approval") {
    return status === "Requested" || status === "Modified";
  }
  return status === filterId;
}

function TodaysEnquiries(props) {
  const { todayEnquiries, tableLists, reservationLoading } =
    useContext(AppContext);
  const [statusFilter, setStatusFilter] = useState("all");

  const parseItem = (item) => {
    return item && typeof item === "string" ? JSON.parse(item) : item;
  };

  useEffect(() => {
    todayEnquiries &&
      todayEnquiries.length != 0 &&
      todayEnquiries.map((item) => {
        const tableData = item?.tables;
        if (!tableData) return;

        let parsedTablles = parseItem(tableData);

        if (parsedTablles && typeof parsedTablles == "string")
          parseItem(parsedTablles);

        if (parsedTablles && parsedTablles.length != 0) {
          const tableNames =
            Array.isArray(parsedTablles) &&
            parsedTablles.map((table) => {
              const tableInfo =
                tableLists && tableLists.find((t) => t.id == table);

              return tableInfo ? tableInfo : null;
            });
          item.tablesDetails = tableNames;
        } else {
          item.tablesDetails = null;
        }
      });
  }, [todayEnquiries, tableLists]);

  const filterCounts = useMemo(() => {
    const list = Array.isArray(todayEnquiries) ? todayEnquiries : [];
    return {
      all: list.length,
      Approved: list.filter((item) => item?.status === "Approved").length,
      Seated: list.filter((item) => item?.status === "Seated").length,
      needs_approval: list.filter(
        (item) => item?.status === "Requested" || item?.status === "Modified"
      ).length,
    };
  }, [todayEnquiries]);

  const filteredData = useMemo(() => {
    if (!todayEnquiries || todayEnquiries.length === 0) return [];

    const byStatus = todayEnquiries.filter((item) =>
      matchesStatusFilter(item, statusFilter)
    );

    const kw = (props.keyword || "").toLowerCase();
    if (!kw) return byStatus;

    return byStatus.filter(
      (item) =>
        item.name?.toLowerCase?.().includes(kw) ||
        item.email?.toLowerCase?.().includes(kw) ||
        item.formattedID?.toLowerCase?.().includes(kw) ||
        String(item.phone || "").includes(props.keyword)
    );
  }, [todayEnquiries, props.keyword, statusFilter]);

  const emptyMessage =
    statusFilter === "all"
      ? "No Enquiries Today"
      : statusFilter === "needs_approval"
      ? "No reservations need approval today"
      : `No ${statusFilter} reservations today`;

  return (
    <Fragment>
      <div
        className="today-status-filters"
        role="tablist"
        aria-label="Filter today's reservations by status"
      >
        {STATUS_FILTERS.map((filter) => {
          const count = filterCounts[filter.id] ?? 0;
          const isActive = statusFilter === filter.id;
          return (
            <button
              key={filter.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={
                isActive
                  ? "today-status-filters__btn is-active"
                  : "today-status-filters__btn"
              }
              onClick={() => setStatusFilter(filter.id)}
            >
              <span>{filter.label}</span>
              <span className="today-status-filters__count">{count}</span>
            </button>
          );
        })}
      </div>

      <EnquiryListPanel
        title="Today's reservations"
        items={filteredData}
        loading={reservationLoading}
        emptyMessage={emptyMessage}
        showStatus
      />
    </Fragment>
  );
}

export default TodaysEnquiries;
